module.exports = __webpack_public_path__ + "static/img/nav-icon_1.da51d3ba.png";